export const normalizePhone = (phone: string): string => {
    const digits = phone.replace(/\D/g, '');

    if (!digits) {
        return '';
    }

    // +7XXXXXXXXXX / 7XXXXXXXXXX
    if (digits.startsWith('7')) {
        return digits.slice(1, 11);
    }

    // 8XXXXXXXXXX
    if (digits.startsWith('8')) {
        return digits.slice(1, 11);
    }

    // Если код 7/8 отсутствует — считаем, что передали непосредственно 10 цифр номера или меньше
    return digits.slice(0, 10);
};
